export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jste v demo režimu. Zůstatky a operace jsou výukové."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přejít do pracovního kabinetu"])}
}